import { render, staticRenderFns } from "./GradientCard.vue?vue&type=template&id=76637236&"
import script from "./GradientCard.vue?vue&type=script&lang=js&"
export * from "./GradientCard.vue?vue&type=script&lang=js&"
import style0 from "./GradientCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports